import React from 'react'

export const AssistIcon = () => {
  return (
    <svg
      width="11"
      height="12"
      viewBox="0 0 11 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.16675 0L9.6169 1.21652L10.8334 1.66667L9.6169 2.11682L9.16675 3.33333L8.7166 2.11682L7.50008 1.66667L8.7166 1.21652L9.16675 0Z"
        fill="white"
      />
      <path
        d="M9.16675 8.66667L9.6169 9.88318L10.8334 10.3333L9.6169 10.7835L9.16675 12L8.7166 10.7835L7.50008 10.3333L8.7166 9.88318L9.16675 8.66667Z"
        fill="white"
      />
      <path
        d="M5.24711 4.91964L4.16675 2L3.08638 4.91964L0.166748 6L3.08638 7.08036L4.16675 10L5.24711 7.08036L8.16675 6L5.24711 4.91964Z"
        fill="white"
      />
    </svg>
  )
}
